module.exports = __webpack_public_path__ + "img/btn-close.5af803d3.svg";